import { render, staticRenderFns } from "./playerIconDecorator.vue?vue&type=template&id=3f424950&scoped=true&"
import script from "./playerIconDecorator.vue?vue&type=script&lang=js&"
export * from "./playerIconDecorator.vue?vue&type=script&lang=js&"
import style0 from "./playerIconDecorator.vue?vue&type=style&index=0&id=3f424950&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f424950",
  null
  
)

export default component.exports